import React from "react";
import T from "prop-types";
import TableDetailRow from "MODULES/shared/components/DetailTable/Detail";
import { shortDate } from "LIB/formatters/date";
import DashedSeparator from "MODULES/shared/components/DashedSeparator/DashedSeparator";

export function ApprovalDetails({ record }) {
  if (record.approved_by || record.approved_updated_at || !record.approved) {
    return [
      <DashedSeparator />,
      <table className="table table-condensed">
        <tbody>
          <TableDetailRow
            label="Approved"
            value={shortDate(record.approved_updated_at)}
            renderIfPresent
          />
          <TableDetailRow
            label="Approved By"
            value={record.approved_by && record.approved_by.full_name}
            renderIfPresent
          />
          <TableDetailRow
            label="Reason For Approval"
            value={
              record.reason_for_approval && record.reason_for_approval.join("/")
            }
            renderIfPresent
          />
        </tbody>
      </table>
    ];
  }

  return null;
}

ApprovalDetails.propTypes = {
  record: T.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/ApprovalDetails/ApprovalDetails.jsx